import React from 'react';

import NavigationButton from './navigationButton';

const NavigationBarDesktop = (props) => {
  return (
    <nav
      className="navigation-bar navigation-bar-desktop "
      aria-label="Hauptnavigation"
    >
      {React.Children.toArray(
        props.enums.map((_enum) => (
          <NavigationButton
            className={'navigation-button-desktop'}
            enum={_enum}
          />
        )),
      )}
    </nav>
  );
};

export default NavigationBarDesktop;
